// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"a2b09e30","315":"d095b0bf","557":"80b21bee","756":"b0f7e69d"}[chunkId] + ".css";
};